import React, { createContext, useContext, useState } from "react";

// Definiere den Typ des Contexts
type DirtyContextType = {
    isDirty: boolean;
    setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

// Erstelle den Context mit dem richtigen Typ
const DirtyContext = createContext<DirtyContextType | undefined>(undefined);

export const DirtyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isDirty, setIsDirty] = useState(false);

    return (
        <DirtyContext.Provider value={{ isDirty, setIsDirty }}>
            {children}
        </DirtyContext.Provider>
    );
};

// Custom Hook zum Verwenden des Contexts
export const useDirty = (): DirtyContextType => {
    const context = useContext(DirtyContext);
    if (!context) {
        throw new Error("useDirty must be used within a DirtyProvider");
    }
    return context;
};